import React from "react";
import ReactExport from "react-export-excel";

const OrdersListExcel = (props) => {
    const {orders} = props;
    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    return (
        <ExcelFile element={<button className="btn btn-sm btn-success btn-export">دانلود خروجی اکسل</button>}>
            <ExcelSheet data={orders} name="OrdersList">
                <ExcelColumn label="کد سفارش" value="id"/>
                <ExcelColumn label="نام مشتری" value="customer_contact_name"/>
                <ExcelColumn label="آخرین وضعیت" value="fa_status"/>
                <ExcelColumn label="هزینه بدون بیمه" value="order_regular_price"/>
                <ExcelColumn label="هزینه با بیمه" value="order_insurance_price"/>
                <ExcelColumn label="تاریخ ثبت سفارش" value="jalali_created_at"/>
            </ExcelSheet>
        </ExcelFile>
    );
}
export default OrdersListExcel;
